import React from "react";
import { skillsData } from "../../data/mock";
import { Database, Code, Server, Settings } from "lucide-react";

const iconMap = {
  Database: Database,
  Code: Code,
  Server: Server,
  Settings: Settings,
};

const SkillsSection = () => {
  return (
    <section id="skills" className="relative">
      <div className="hex-pattern absolute inset-0 pointer-events-none" />
      <div className="section-container relative z-10">
        <div className="text-center mb-14">
          <span className="section-label justify-center">Tech Stack</span>
          <h2 className="section-title">Technical Arsenal</h2>
          <div className="gradient-line mx-auto" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {skillsData.categories.map((cat, i) => {
            const IconComp = iconMap[cat.icon] || Database;
            return (
              <div
                key={i}
                className="glass-card p-6 group hover:border-[#06B6D4]/25 transition-all duration-300 relative"
              >
                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-12 h-12 overflow-hidden">
                  <div className="absolute top-0 right-0 w-[1px] h-6 bg-gradient-to-b from-[#06B6D4]/30 to-transparent" />
                  <div className="absolute top-0 right-0 h-[1px] w-6 bg-gradient-to-l from-[#06B6D4]/30 to-transparent" />
                </div>

                <div className="relative z-10">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-lg bg-[#06B6D4]/8 border border-[#06B6D4]/10 flex items-center justify-center group-hover:bg-[#06B6D4]/12 group-hover:border-[#06B6D4]/20 transition-all duration-300">
                      <IconComp size={18} className="text-[#06B6D4]" />
                    </div>
                    <div>
                      <h3 className="text-sm font-bold font-['Figtree'] text-[#F1F5F9]">
                        {cat.name}
                      </h3>
                      <span className="text-[9px] text-[#334155] font-['Fira_Code']">
                        {cat.skills.length} skills
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-1.5">
                    {cat.skills.map((skill) => (
                      <span
                        key={skill}
                        className="px-2.5 py-1 rounded text-[10px] bg-[#0A1628] text-[#64748B] font-['Fira_Code'] border border-[#1E293B]/60 hover:text-[#06B6D4] hover:border-[#06B6D4]/20 hover:bg-[#06B6D4]/5 transition-all duration-200 cursor-default"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Data pipeline visualization */}
        <div className="mt-12 flex items-center justify-center gap-3 opacity-30">
          <div className="h-[1px] w-16 bg-gradient-to-r from-transparent to-[#06B6D4]" />
          <div className="w-2 h-2 rounded-full bg-[#06B6D4]" />
          <div className="h-[1px] w-32 bg-[#06B6D4]" />
          <div className="w-3 h-3 rounded border border-[#06B6D4] rotate-45" />
          <div className="h-[1px] w-32 bg-[#06B6D4]" />
          <div className="w-2 h-2 rounded-full bg-[#06B6D4]" />
          <div className="h-[1px] w-16 bg-gradient-to-l from-transparent to-[#06B6D4]" />
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
